import { useState } from "react";
import moment from "moment";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useOutletContext, useParams } from "react-router";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { selectSubEntities } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { sortArrayByKey } from "features/helpers/utils";

const useEcoScanState = () => {
  const projectPartyList = useSelector(selectSubEntities);

  const [entityName] = useOutletContext();
  const [dateRange, setDateRange] = useState([
    moment().utc().startOf("day").subtract(6, "days").valueOf(),
    moment().utc().endOf("day").valueOf(),
  ]);
  const [overviewFilterValue, setOverviewFilterValue] =
    useState("transactionCount");
  const dispatchSnackbar = useDispatchSnackbar();

  const [selectedParty, setSelectedParty] = useState([""]);

  const [projectPartyData, setProjectPartyData] = useState({});
  const [projectPartyDataLoading, setProjectPartyDataDataLoading] =
    useState(false);
  const [morphTableData, setMorphTableData] = useState([]);
  const [morphTableDataLoading, setMorphTableDataLoading] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("");

  const fetchMorphLineData = async ({ types, entities, from, to, page }) => {
    try {
      setProjectPartyDataDataLoading(true);
      const { data } = await axios({
        method: "POST",
        url: `${apiUrl}/api/ecoscan/${entityName}/lineChart`,
        data: {
          from: from ? moment(from).valueOf() : undefined,
          to: to ? moment(to).valueOf() : undefined,
          entities: entities,
          types: types,
          page,
        },
      });

      setProjectPartyData(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setProjectPartyDataDataLoading(false);
    }
  };

  const fetchMorphTableData = async ({ from, to, type }) => {
    try {
      setMorphTableDataLoading(true);
      const { data } = await axios({
        method: "POST",
        url: `${apiUrl}/api/ecoscan/${entityName}/table`,
        data: {
          from: moment(from).valueOf(),
          to: moment(to).valueOf(),
        },
      });
      let newOrderBy = "transactionCount";

      if (type === "communityAnalysis") {
        newOrderBy = "newDiscordMember";
      }
      if (type === "websiteTraffic") {
        newOrderBy = "websiteTrafficWalletCount";
      }
      const newOrder = "desc";
      const newArr = sortArrayByKey(data, newOrderBy, newOrder);
      setOrder(newOrder);
      setOrderBy(newOrderBy);
      setMorphTableData(newArr);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setMorphTableDataLoading(false);
    }
  };

  return {
    dateRange,
    setDateRange,
    overviewFilterValue,
    setOverviewFilterValue,
    selectedParty,
    setSelectedParty,
    projectPartyList,
    projectPartyData,
    setProjectPartyData,
    projectPartyDataLoading,
    morphTableData,
    setMorphTableData,
    morphTableDataLoading,
    fetchMorphLineData,
    fetchMorphTableData,
    order,
    setOrder,
    orderBy,
    setOrderBy,
  };
};

export default useEcoScanState;
